import { TYPE } from "../../utils/constants";
import SearchableSelect from "./ChoiceDropdown";
import { isChoiceType } from "../../utils/helpers";


const QuestionItem = ({ question, index, value, onChange }) => {
  const isMulti = question.type === TYPE.MULTIPLE_CHOICE;
  const isChoice = isChoiceType(question.type);

  const selectedIds = Array.isArray(value?.selected) ? value.selected : [];
  const otherText = value?.otherText || "";

  const handleMultiToggle = (opt) => {
    const strId = String(opt.id);
    const alreadySelected = selectedIds.map(String).includes(strId);
    const updated = alreadySelected
      ? selectedIds.filter((v) => String(v) !== strId)
      : [...selectedIds, opt.id];
    const newOtherText = opt.is_other_option && alreadySelected ? "" : otherText;
    onChange({ selected: updated, otherText: newOtherText });
  };

  const handleSingleSelect = (opt) => {
    onChange({ selected: opt.id, otherText: opt.is_other_option ? otherText : "" });
  };

  const singleSelected = isMulti
    ? null
    : typeof value === "object" && value !== null && !Array.isArray(value)
      ? value.selected
      : value;

  const otherOpt = question.assessment_options?.find((o) => o.is_other_option);
  const isOtherSelected =
    otherOpt &&
    (isMulti
      ? selectedIds.map(String).includes(String(otherOpt.id))
      : String(singleSelected) === String(otherOpt.id));

  return (
    <div>
      <p className="text-[15px] font-semibold text-gray-800 mb-0.5">
        <span className="mr-1 text-gray-400">{index}.</span>
        {question.title}
        {question.is_required !== false && <span className="text-red-400 ml-1">*</span>}
      </p>
      {question.hindi_title && <p className="text-sm text-gray-500 mb-2 ml-4">{question.hindi_title}</p>}

      {question.type === TYPE.OPEN_TEXT && (
        <textarea
          rows={2}
          className="w-full border border-gray-300 rounded-lg p-3 text-[15px] text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary hover:border-gray-400 transition-colors mt-1.5 resize-none"
          placeholder="Type your answer..."
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      )}

      {question.type === TYPE.RATING && (
        <div className="mt-3">
          <div className="flex items-center gap-2 sm:gap-3">
            {[1, 2, 3, 4, 5].map((n) => {
              const filled = value !== undefined && value !== null && n <= value;
              const isSelected = value === n;
              return (
                <button
                  key={n}
                  type="button"
                  onClick={() => onChange(n)}
                  aria-pressed={isSelected}
                  className={`flex-1 h-12 rounded-lg border-2 text-sm font-semibold transition-all duration-150 active:scale-95 ${filled
                    ? "bg-primary border-primary text-white shadow-sm"
                    : "bg-white border-gray-200 text-gray-400 hover:border-primary/50 hover:text-primary hover:-translate-y-0.5 hover:shadow-sm"
                    } ${isSelected ? "ring-2 ring-primary/25 ring-offset-1" : ""}`}
                >
                  {n}
                </button>
              );
            })}
          </div>
          <div className="flex items-center justify-between mt-1.5 px-0.5">
            <span className="text-[11px] text-gray-400">Not great</span>
            <span className="text-[11px] text-gray-400">Excellent</span>
          </div>
        </div>
      )}

      {isChoice && (
        <div className="mt-2 space-y-2">
          <SearchableSelect
            options={question.assessment_options || []}
            isMulti={isMulti}
            selectedIds={selectedIds}
            singleSelected={singleSelected}
            onToggle={handleMultiToggle}
            onSelect={handleSingleSelect}
          />
          {isMulti && <p className="text-xs text-gray-400 ml-1">Select all that apply</p>}

          {/* Moved out of the dropdown entirely — this is its own required
              field directly under the question, only rendered once "Other"
              is actually selected. */}
          {isOtherSelected && (
            <div className="pt-1">
              <label className="block text-xs font-medium text-gray-600 mb-1">
                Please specify <span className="text-red-400">*</span>
              </label>
              <input
                type="text"
                autoFocus
                value={otherText}
                onChange={(e) =>
                  onChange({ selected: isMulti ? selectedIds : singleSelected, otherText: e.target.value })
                }
                placeholder="Type here..."
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default QuestionItem;